import ErrorMessages from './ErrorMessages';

interface TextareaProps {
	disabled?: boolean;
	errorMessages?: string[];
	label?: string;
	name: string;
	onChange: (value: string) => void;
	placeholder?: string;
	refProp?: React.Ref<HTMLTextAreaElement>;
	required?: boolean;
	value: string;
}

export default function Textarea({
	disabled = false,
	errorMessages = [],
	label = '',
	name,
	onChange,
	placeholder = '',
	refProp,
	required = false,
	value,
}: TextareaProps) {
	const inputAttributes = {
		disabled,
		id: name,
		name,
		onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => onChange(e.target.value),
		placeholder,
		required,
		ref: refProp,
		value,
	};

	return (
		<div className="form-field-wrapper" data-field-name={name}>
			<div className="form-field" data-field-type="textarea" data-field-name={name}>
				{label && <label htmlFor={name}>{label}</label>}
				<textarea {...inputAttributes} />
			</div>

			<ErrorMessages messages={errorMessages} />
		</div>
	);
}
